<template>
  <div
    class="flex animate-pulse items-start gap-3 border-b border-n-slate-3 px-3 py-3"
  >
    <div class="mt-0.5 size-9 shrink-0 rounded-full bg-n-alpha-2" />
    <div class="min-w-0 flex-1 space-y-2 py-0.5">
      <div class="flex justify-between gap-2">
        <div class="h-4 w-2/3 rounded bg-n-alpha-2" />
        <div class="h-3 w-10 rounded bg-n-alpha-2" />
      </div>
      <div class="h-3.5 w-4/5 rounded bg-n-alpha-2" />
    </div>
  </div>
</template>
